export const TAGS = {
  ACCOUNT_LIST: 'accountList',
  USERS_LIST: 'accountUserslist',
  DOMAIN_LIST: 'accountDomainList',
  DIRECT_ACCESS_ACCOUNTS: 'directAccessAccounts',
};
